import * as React from "react";
import Box, {BoxProps} from '@mui/material/Box';
import {styled} from '@mui/material/styles';

export const CBox = styled(Box)<BoxProps>(
  (/* { theme } */) => ({
  }),
);
